import { ScrollData } from './conversationIntiniteList.types';

export const scrollToBottom = (element: HTMLDivElement) => {
  element.scrollTop = element.scrollHeight;
};

export const isScrolledToTheBottom = (containerNode: HTMLDivElement, epsilon = 10): boolean => {
  const { clientHeight, scrollHeight, scrollTop } = containerNode;

  return scrollHeight - clientHeight - scrollTop < epsilon;
};

export const getContainerScrollState = (
  containerNode: HTMLDivElement,
  listNode: HTMLDivElement
): ScrollData => {
  const { scrollHeight, scrollTop } = containerNode;
  const isScrolledToBottom = isScrolledToTheBottom(containerNode);

  return {
    firstItem: listNode.firstElementChild,
    isScrolledToBottom,
    lastItem: listNode.lastElementChild,
    scrollHeight,
    scrollTop,
  };
};
